import { useState, useEffect } from 'react';
import { createUseGesture, pinchAction } from '@use-gesture/react';

const useGesture = createUseGesture([pinchAction]);

const MIN_FONT = 15;
const MAX_FONT = 70;

// צביטה להגדלת/הקטנת פונט: מחזיר את גודל הפונט הנוכחי ושומר ל-localStorage בסוף המחווה.
// על אלמנט היעד להיות עם touch-action: pan-y כדי שהצביטה תגיע ל-JS והגלילה תישאר לדפדפן.
export function useFontPinch(ref) {
  const [stateFontSize, setStateFontSize] = useState(20);

  useEffect(() => {
    const settings = JSON.parse(localStorage.getItem('tfilulari/settings'));
    if (settings?.fontSize) setStateFontSize(settings.fontSize);

    // חוסם את זום העמוד של ספארי כדי שהצביטה תגיע אלינו
    const handler = (e) => e.preventDefault();
    document.addEventListener('gesturestart', handler);
    document.addEventListener('gesturechange', handler);
    document.addEventListener('gestureend', handler);
    return () => {
      document.removeEventListener('gesturestart', handler);
      document.removeEventListener('gesturechange', handler);
      document.removeEventListener('gestureend', handler);
    };
  }, []);

  useGesture(
    {
      onPinch: ({ first, movement: [ms], last, memo }) => {
        if (first) memo = stateFontSize;

        const fontSize = Math.round(Math.max(MIN_FONT, Math.min(MAX_FONT, memo * ms)));
        setStateFontSize(fontSize);
        if (last) {
          const settings = JSON.parse(localStorage.getItem('tfilulari/settings')) || {};
          localStorage.setItem('tfilulari/settings', JSON.stringify({ ...settings, fontSize }));
        }

        return memo;
      }
    },
    {
      target: ref,
      eventOptions: { passive: false },
    }
  );

  return stateFontSize;
}
